import axios from 'axios';

import { getSpotifyUserId } from '../auth/spotifyUserId';
import { getFromLocalStorageWithExpiry } from '../../utils/localstorage';

const defaultBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL || 'http://127.0.0.1:4000';

export const backendClient = axios.create({
  baseURL: defaultBaseUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

backendClient.interceptors.request.use((config) => {
  const spotifyUserId = getSpotifyUserId();
  const accessToken =
    (getFromLocalStorageWithExpiry('access_token') as string | undefined) ??
    (getFromLocalStorageWithExpiry('spotify_access_token') as string | undefined) ??
    undefined;

  if (spotifyUserId) {
    config.headers = config.headers ?? {};
    config.headers['X-User-Id'] = spotifyUserId;
  }

  if (accessToken) {
    config.headers = config.headers ?? {};
    config.headers['X-Spotify-Access-Token'] = accessToken;
  }

  return config;
});
